/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pando': {
    width: 27,
    height: 28,
    viewBox: '0 0 27 28',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 15.627c0 6.997 5.986 12.361 12.983 12.361a13.216 13.216 0 0 0 13.761-13.76C26.744 7.085 20.667 1 12.594 0v3.333C5.599 3.333 0 8.32 0 15.627z" _fill="#FD3"/><path pid="1" d="M13.973 18.174c-1.278 0-2.43-.558-3.114-1.53v5.976H8.843V9.12h1.423l.593 1.224c.63-.882 1.674-1.368 2.97-1.368 2.592 0 4.518 1.944 4.518 4.536 0 2.61-1.926 4.662-4.374 4.662zm-.432-1.836c1.638 0 2.628-1.314 2.628-2.79 0-1.566-1.098-2.772-2.754-2.772-1.53 0-2.556 1.044-2.556 2.628v.18c0 1.584 1.134 2.754 2.682 2.754zM15.438 21.191a1.424 1.424 0 1 1 2.847 0 1.424 1.424 0 0 1-2.847 0z" _fill="#003D31"/>'
  }
})
